export const PAYMENT_METHOD_NAME = 'dokan_paypal_marketplace';
